import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import apiClient from '../../../server/server';
import { getAuthToken } from '@/utils/authStorage';

// Get base URL from the apiClient configuration
const baseURL = apiClient.defaults.baseURL;

export const mailApiSlice = createApi({
  reducerPath: 'mailApi',
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
    prepareHeaders: (headers, { getState }) => {
      // Add auth token if available
      const token = getAuthToken();
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['Mail'],
  endpoints: (builder) => ({
    // Bulk invite - sends invitation emails to multiple recipients
    bulkInvite: builder.mutation({
      query: ({ emails }) => ({
        url: '/invitations/bulk-invite',
        method: 'POST',
        body: { emails },
      }),
      invalidatesTags: ['Mail'],
    }),
  }),
});

export const {
  useBulkInviteMutation,
} = mailApiSlice;
